var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { property, query, queryAssignedElements } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { when } from 'lit/directives/when.js';
import { debounce, isNil } from 'lodash-es';
import '../../button/default/sds-button.lit';
import '../../icon/sds-icon.lit';
import { sdsCustomElement } from '../../utilities/custom-components';
import { SdsTreeDataNodeBase } from './_sds-tree-data-node-base';
import { SdsTreeLoadMoreNode } from './sds-tree-load-more-node.lit';
import styles from './sds-tree-node.lit.scss';
import { SdsTreeTotalDataNode } from './sds-tree-total-data-node.lit';
import { getMaxFirstColumnSize } from './utilities';
/**
 * Standard data node that contains cells.
 *
 * @slot nodes - Slot for the nodes.
 *
 * @slot data - Slot for the data. Cells are rendered in this slot.
 *
 * @tag sds-tree-node
 *
 * @fires sds.tree-node.expand - Fired when the node is expanded.
 * Event is of `CustomEvent` type with details of `{identifier: string, level: number}` type
 * @fires sds.tree-node.collapse - Fired when the node is collapsed.
 * Event is of `CustomEvent` type with details of `{identifier: string, level: number}` type
 */
let SdsTreeNode = (() => {
    var _SdsTreeNode_childCount_accessor_storage, _SdsTreeNode_selected_accessor_storage, _SdsTreeNode_childElements_accessor_storage, _SdsTreeNode_childTreeCells_accessor_storage, _SdsTreeNode_control_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-tree-node')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsTreeDataNodeBase;
    let _childCount_decorators;
    let _childCount_initializers = [];
    let _childCount_extraInitializers = [];
    let _selected_decorators;
    let _selected_initializers = [];
    let _selected_extraInitializers = [];
    let _childElements_decorators;
    let _childElements_initializers = [];
    let _childElements_extraInitializers = [];
    let _childTreeCells_decorators;
    let _childTreeCells_initializers = [];
    let _childTreeCells_extraInitializers = [];
    let _control_decorators;
    let _control_initializers = [];
    let _control_extraInitializers = [];
    var SdsTreeNode = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsTreeNode_childCount_accessor_storage.set(this, __runInitializers(this, _childCount_initializers, undefined));
            _SdsTreeNode_selected_accessor_storage.set(this, (__runInitializers(this, _childCount_extraInitializers), __runInitializers(this, _selected_initializers, false)));
            _SdsTreeNode_childElements_accessor_storage.set(this, (__runInitializers(this, _selected_extraInitializers), __runInitializers(this, _childElements_initializers, void 0)));
            _SdsTreeNode_childTreeCells_accessor_storage.set(this, (__runInitializers(this, _childElements_extraInitializers), __runInitializers(this, _childTreeCells_initializers, void 0)));
            this.firstColumnSizeBeforeExpand = (__runInitializers(this, _childTreeCells_extraInitializers), 0);
            this.firstColumnSizeAfterExpand = 0;
            this.rowPosition = undefined;
            this.colPosition = undefined;
            this.skipCollapseExpand = false;
            _SdsTreeNode_control_accessor_storage.set(this, __runInitializers(this, _control_initializers, void 0));
            /**
             * The child count updating handler. This is used to update the child count property of this node.
             */
            this.childCountUpdatingHandler = (__runInitializers(this, _control_extraInitializers), () => {
                if (isNil(this.childCount) || this.childCount < this.childElements.length) {
                    this.childCount = this.childNodeIds.size;
                }
            });
            /**
             * The debounced version of the child count updating handler.
             */
            this.childCountUpdatingHandlerDebounced = debounce(this.childCountUpdatingHandler, 400, {
                leading: true,
                trailing: true,
            });
            /**
             * The froze columns updating handler. This is used to update the frozen columns of this node.
             */
            this.frozeColumnsUpdatingHandler = debounce(() => this.updateFrozenColumns(), 400, {
                leading: true,
                trailing: true,
            });
            /**
             * The children level updating handler. This is used to update the level of the child nodes of this node.
             */
            this.childrenLevelUpdatingHandler = debounce(() => this.updateChildrenLevels(), 400, {
                leading: true,
                trailing: true,
            });
            /**
             * The toggling handler. This is used to toggle the visibility of the child nodes.
             */
            this.togglingHandler = () => void this.toggle()
                .catch(e => console.error(e))
                .then();
            this.nodeDataChangeHandler = () => {
                this.updatePositions();
                this.updateFrozenColumns();
            };
        }
        static firstDefinedOrCalculation(arg1, arg2, calculator) {
            if (arg1 === undefined) {
                return arg2;
            }
            else if (arg2 === undefined) {
                return arg1;
            }
            else {
                return calculator(arg1, arg2);
            }
        }
        /**
         * Number of children that this node has. If this is not set the node will count the number of children in `nodes` slot.
         */
        get childCount() { return __classPrivateFieldGet(this, _SdsTreeNode_childCount_accessor_storage, "f"); }
        set childCount(value) { __classPrivateFieldSet(this, _SdsTreeNode_childCount_accessor_storage, value, "f"); }
        get selected() { return __classPrivateFieldGet(this, _SdsTreeNode_selected_accessor_storage, "f"); }
        set selected(value) { __classPrivateFieldSet(this, _SdsTreeNode_selected_accessor_storage, value, "f"); }
        /**
         * The child elements of this node.
         */
        get childElements() { return __classPrivateFieldGet(this, _SdsTreeNode_childElements_accessor_storage, "f"); }
        set childElements(value) { __classPrivateFieldSet(this, _SdsTreeNode_childElements_accessor_storage, value, "f"); }
        get childTreeCells() { return __classPrivateFieldGet(this, _SdsTreeNode_childTreeCells_accessor_storage, "f"); }
        set childTreeCells(value) { __classPrivateFieldSet(this, _SdsTreeNode_childTreeCells_accessor_storage, value, "f"); }
        /**
         * The control element of this node.
         */
        get control() { return __classPrivateFieldGet(this, _SdsTreeNode_control_accessor_storage, "f"); }
        set control(value) { __classPrivateFieldSet(this, _SdsTreeNode_control_accessor_storage, value, "f"); }
        get stateNode() {
            var _a, _b;
            if (isNil(this.nodeId)) {
                throw new Error(`Node with has no nodeId`);
            }
            const node = (_b = (_a = this.tree) === null || _a === void 0 ? void 0 : _a.hierarchicalState) === null || _b === void 0 ? void 0 : _b.getNode(this.nodeId);
            if (isNil(node)) {
                throw new Error(`Node with id ${this.nodeId} not found in hierarchical state`);
            }
            else {
                return node;
            }
        }
        updateIsLeafStatus() {
            this._isLeaf =
                (this.childCount === undefined || this.childCount === 0) &&
                    this.childElements.length === 0;
        }
        /**
         * Updates the level of this node based on the level of its parent node.
         *
         * @param parentLvl - The level of the parent node.
         */
        updateLevelByParent(parentLvl) {
            var _a, _b;
            const oldLevel = this.level;
            super.updateLevelByParent(parentLvl);
            if (oldLevel !== this.level) {
                (_a = this.tree) === null || _a === void 0 ? void 0 : _a.unregisterNodeAtLevel(this, oldLevel);
                (_b = this.tree) === null || _b === void 0 ? void 0 : _b.registerNodeAtLevel(this, this.level);
                this.updateChildrenLevels();
            }
        }
        /**
         * Freezes the specified number of columns of this node.
         *
         * @param count - The number of columns to freeze.
         */
        freezeColumns(count) {
            this.updateFrozenColumns(count);
        }
        /**
         * Unfreezes all columns of this node.
         */
        unFreezeAllColumns() {
            this.childTreeCells.forEach(cell => cell.classList.remove('sds-tree-cell__frozen'));
            this.childElements.forEach(child => {
                child.unFreezeAllColumns();
            });
        }
        /**
         * Adds a border on scroll for the specified number of frozen columns of this node.
         *
         * @param frozenColumnCount - The number of frozen columns.
         */
        addBorderOnScroll(frozenColumnCount) {
            void this.updateComplete.then(() => {
                this.childTreeCells[frozenColumnCount - 1].classList.add('sds-tree-cell__scroll-border');
                this.childElements.forEach(child => {
                    child.addBorderOnScroll(frozenColumnCount);
                });
            }, e => console.error(e));
        }
        /**
         * Handles the cell resize event for this node.
         *
         * @param indexes - The indexes of the resized cells.
         */
        handleCellResize(indexes) {
            for (const index of indexes) {
                this.childTreeCells[index].handleResize();
            }
            for (const child of this.childElements) {
                if (child instanceof SdsTreeNode) {
                    child.handleCellResize(indexes);
                }
            }
        }
        async connectedCallback() {
            var _a;
            // Check for selected attribute before calling super
            const hasSelectedAttr = this.hasAttribute('selected');
            await super.connectedCallback();
            await this.nodeIsReady;
            (_a = this.tree) === null || _a === void 0 ? void 0 : _a.registerNodeAtLevel(this, this.level);
            // Check if selected attribute is set and sync the property
            if (this.hasAttribute('selected') && !this.selected) {
                this.selected = true;
            }
            else if (hasSelectedAttr && !this.selected) {
                this.setAttribute('selected', '');
                this.selected = true;
            }
        }
        disconnectedCallback() {
            var _a, _b, _c;
            (_a = this.tree) === null || _a === void 0 ? void 0 : _a.unregisterNodeAtLevel(this, this.level);
            super.disconnectedCallback();
            const node = (_c = (_b = this.tree) === null || _b === void 0 ? void 0 : _b.hierarchicalState) === null || _c === void 0 ? void 0 : _c.getNode(this.id);
            if (!isNil(node)) {
                this.removeNodeDataChangeHandlers(node);
            }
        }
        /**
         * Removes the border on scroll for the specified number of frozen columns of this node.
         *
         * @param frozenColumnCount - The number of frozen columns.
         */
        removeBorderOnScroll(frozenColumnCount) {
            this.childTreeCells[frozenColumnCount - 1].classList.remove('sds-tree-cell__scroll-border');
            this.childElements.forEach(child => {
                child.removeBorderOnScroll(frozenColumnCount);
            });
        }
        /**
         * Adds an event listener to this node for the specified event type.
         *
         * @param type - The event type.
         * @param listener - The event listener.
         * @param options - The event listener options.
         */
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        /**
         * Returns the index of the given child node in the view.
         *
         * @param node - The child node to find the index of.
         * @returns The index of the child node in the view.
         */
        nodeOrderInView(node) {
            return this.childElements.findIndex(elem => elem === node);
        }
        nodeRegisteredCallback() {
            this.registerNodeDataChangeHandlers();
        }
        /**
         * Returns the number of child nodes of this node.
         *
         * @returns The number of child nodes.
         */
        getChildCount() {
            return this.childCount;
        }
        /**
         * Called when the first update of this node occurs.
         */
        async firstUpdated() {
            var _a;
            await this.updateComplete;
            if (this.isCollapsed) {
                await this.collapse(false);
            }
            (_a = this.control) === null || _a === void 0 ? void 0 : _a.addEventListener('click', this.togglingHandler);
            this.updateChildrenLevels();
            this.childCountUpdatingHandler();
            if (this.isLeaf) {
                this.isCollapsed = false;
            }
            // Ensure selection state is applied after component is fully rendered
            await this.updateComplete;
            // Double-check if we need to sync the attribute
            if (this.hasAttribute('selected') && !this.selected) {
                this.selected = true;
            }
            this.updateChildSelectionState();
        }
        /**
         * Called before this node is updated.
         *
         * @param changedProperties - The changed properties.
         */
        async willUpdate(changedProperties) {
            super.willUpdate(changedProperties);
            if (changedProperties.has('isCollapsed') &&
                changedProperties.get('isCollapsed') !== undefined &&
                !this.skipCollapseExpand) {
                if (this.isCollapsed) {
                    await this.collapse();
                }
                else {
                    await this.expand();
                }
            }
            else if (this.skipCollapseExpand) {
                void this.updateComplete.then(() => {
                    this.skipCollapseExpand = false;
                });
            }
            if (changedProperties.has('childCount')) {
                this.updateIsLeafStatus();
                if (this.isLeaf) {
                    this.isCollapsed = false;
                }
            }
            if (changedProperties.has('isLeaf') && this.isLeaf) {
                this.isCollapsed = false;
            }
            else if (!this.isLeaf && !this.isCollapsed) {
                await this.expand(false);
            }
            if (changedProperties.has('selected')) {
                this.updateChildSelectionState();
            }
        }
        /**
         * Called when a child node is removed from this node.
         */
        childRemovedCallback() {
            this.childrenLevelUpdatingHandler();
            this.childCountUpdatingHandlerDebounced();
            if (this.childElements.length === 0) {
                this.isLeaf = true;
            }
            this.updateChildSelectionState();
        }
        /**
         * Called when a child node is added to this node.
         */
        childAddedCallback() {
            this.childrenLevelUpdatingHandler();
            this.childCountUpdatingHandlerDebounced();
            if (this.isLeaf) {
                this.isLeaf = false;
            }
            this.updateChildSelectionState();
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            // Update selection state when child elements change
            if (changedProperties.has('childElements')) {
                this.updateChildSelectionState();
            }
        }
        renderData() {
            return html ` <slot name="data" part="table-data" class="sds-tree-node-data"></slot> `;
        }
        renderNodes() {
            return html `
            <slot name="nodes" class="sds-tree-nodes" style="${styleMap(this.slotStyles)}"></slot>
        `;
        }
        customStyles() {
            return html `
            <style>
                ${when(!isNil(this.colPosition), () => {
                return html ` .sds-tree-inner-column { grid-column: ${this.colPosition}; } `;
            })}
                ${when(!isNil(this.rowPosition), () => {
                return html ` .sds-tree-inner-column { grid-row: ${this.rowPosition}; } `;
            })}
            </style>
        `;
        }
        renderNodeControl(isCollapsed) {
            return html `
            <sds-button
                id="control"
                type="secondary"
                size="sm"
                class="sds-tree__action sds-tree-inner-column"
                icon="${isCollapsed ? 'plus_box' : 'minus_box'}"
            ></sds-button>
        `;
        }
        renderLeafIcon() {
            return html `
            <sds-icon
                size="16"
                name="radio_button"
                class="sds-tree__icon sds-tree__icon--radio sds-tree-inner-column"
            ></sds-icon>
        `;
        }
        /**
         * Reveals this node.
         *
         * @param update - Whether to update this node after it is revealed.
         * @returns A promise that resolves after the node is revealed.
         */
        async reveal(update = true) {
            if (update) {
                this.requestUpdate();
            }
            this.updateFrozenColumns();
            const childrenReveals = this.childElements
                .filter(elem => elem instanceof SdsTreeNode)
                .map(elem => elem.reveal(update));
            await Promise.all([...childrenReveals]);
        }
        /**
         * Conceals this node.
         *
         * @param update - Whether to update this node after it is concealed.
         * @returns A promise that resolves after the node is concealed.
         */
        async conceal(update = true) {
            if (update) {
                this.requestUpdate();
            }
            const childrenConcealment = this.childElements
                .filter(elem => elem instanceof SdsTreeNode)
                .map(elem => elem.conceal(update));
            await Promise.all([...childrenConcealment]);
        }
        removeNodeDataChangeHandlers(node) {
            if (!isNil(node)) {
                node.removeDataAdditionListener(this.nodeDataChangeHandler);
                node.removeDataUpdateListener(this.nodeDataChangeHandler);
                node.removeDataRemovalListener(this.nodeDataChangeHandler);
            }
            else {
                console.error(`Node with id ${this.id} not found in hierarchical state`);
            }
        }
        registerNodeDataChangeHandlers() {
            var _a, _b;
            if (isNil(this.nodeId)) {
                return;
            }
            const node = (_b = (_a = this.tree) === null || _a === void 0 ? void 0 : _a.hierarchicalState) === null || _b === void 0 ? void 0 : _b.getNode(this.nodeId);
            if (!isNil(node)) {
                node.registerDataAdditionListener(this.nodeDataChangeHandler);
                node.registerDataRemovalListener(this.nodeDataChangeHandler);
                node.registerDataUpdateListener(this.nodeDataChangeHandler);
            }
            else {
                console.error(`Node with id ${this.nodeId} not found in hierarchical state`);
            }
        }
        updateChildrenLevels() {
            this.childElements.forEach(child => {
                child.updateLevelByParent(this.level);
                child.requestUpdate();
            });
        }
        updatePositions() {
            const pos = this.stateNode.calculatePositions();
            const rowPositionCandidate = pos.rowPosition
                ? `auto/span ${pos.rowPosition.end - pos.rowPosition.start}`
                : undefined;
            if (rowPositionCandidate !== this.rowPosition) {
                const oldPos = this.rowPosition;
                this.rowPosition = rowPositionCandidate;
                this.requestUpdate('rowPosition', oldPos);
            }
        }
        updateFrozenColumns(count = this.frozenColumns) {
            if (this.childTreeCells.length >= count) {
                for (let i = 0; i < count; i++) {
                    this.childTreeCells[i].classList.add('sds-tree-cell__frozen');
                    this.childTreeCells[i].freeze();
                }
            }
        }
        updateChildSelectionState() {
            // Ensure the attribute is properly set
            if (this.selected && !this.hasAttribute('selected')) {
                this.setAttribute('selected', '');
            }
            else if (!this.selected && this.hasAttribute('selected')) {
                this.removeAttribute('selected');
            }
            this.childElements.forEach(child => {
                if (child instanceof SdsTreeNode ||
                    child instanceof SdsTreeLoadMoreNode ||
                    child instanceof SdsTreeTotalDataNode) {
                    child.selected = this.selected;
                }
            });
        }
        /**
         * Collapses this node.
         *
         * @param update - Whether to update this node after it is collapsed.
         * @returns A promise that resolves after the node is collapsed.
         */
        async collapse(update = true) {
            this.slotStyles.display = 'none';
            if (update) {
                this.isCollapsed = true;
                const maxSize = getMaxFirstColumnSize(this.getNotHiddenNodesInSameLevel());
                await this.setFirstColumnSize(maxSize);
                this.dispatchCollapse();
            }
            await this.conceal(false);
        }
        async collapseWithoutResize() {
            this.skipCollapseExpand = true;
            this.slotStyles.display = 'none';
            this.isCollapsed = true;
            this.dispatchCollapse();
            await this.conceal(false);
        }
        /**
         * Expands this node.
         *
         * @param update - Whether to update this node after it is expanded.
         * @returns A promise that resolves after the node is expanded.
         */
        async expand(update = true) {
            var _a, _b;
            this.slotStyles.display = 'inherit';
            const elems = (_b = (_a = this.tree) === null || _a === void 0 ? void 0 : _a.getNodesAtLevel(this.level)) !== null && _b !== void 0 ? _b : [];
            if (!this.firstColumnSizeBeforeExpand) {
                elems.forEach(elem => {
                    elem.firstColumnSizeBeforeExpand = this.getFirstColumnSize();
                    elem.firstColumnSizeAfterExpand = this.getFirstColumnSize();
                });
            }
            if (update) {
                this.isCollapsed = false;
                if (this.isChange1stColumnWidth()) {
                    elems.forEach(elem => (elem.firstColumnSizeAfterExpand = this.firstColumnSizeBeforeExpand + 40));
                }
                const maxSize = getMaxFirstColumnSize(elems);
                await this.setFirstColumnSize(maxSize);
                this.dispatchExpand();
            }
            await this.reveal(false);
        }
        async expandWithoutResize() {
            var _a;
            this.slotStyles.display = 'inherit';
            this.skipCollapseExpand = true;
            const elems = Array.from(((_a = this.tree) === null || _a === void 0 ? void 0 : _a.querySelectorAll(`sds-tree-node[level='${this.level}']`)) || []).filter(item => item instanceof SdsTreeNode);
            if (!this.firstColumnSizeBeforeExpand) {
                elems.forEach(elem => {
                    elem.firstColumnSizeBeforeExpand = this.getFirstColumnSize();
                    elem.firstColumnSizeAfterExpand = this.getFirstColumnSize();
                });
            }
            this.isCollapsed = false;
            if (this.isChange1stColumnWidth()) {
                elems.forEach(elem => (elem.firstColumnSizeAfterExpand = this.firstColumnSizeBeforeExpand + 40));
            }
            this.dispatchExpand();
            await this.reveal(false);
        }
        getNotHiddenNodesInSameLevel() {
            if (!this.tree)
                return [];
            return this.tree
                .getNodesAtLevel(this.level)
                .filter(node => window.getComputedStyle(node).display === 'grid');
        }
        getFirstColumnSize() {
            var _a;
            if ((_a = this.tree) === null || _a === void 0 ? void 0 : _a.columnSizes) {
                const columnSizesArray = this.tree.columnSizes.split(' ');
                const currentSize = parseFloat(columnSizesArray[0]);
                if (!isNaN(currentSize)) {
                    return currentSize;
                }
            }
            return 0;
        }
        async setFirstColumnSize(newSize) {
            var _a;
            await ((_a = this.tree) === null || _a === void 0 ? void 0 : _a.expandCollapseColumn(newSize));
        }
        isChange1stColumnWidth() {
            var _a, _b;
            const nameDiv = (_b = (_a = this.childTreeCells[0]) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('div');
            return nameDiv ? nameDiv.clientWidth < 120 : false;
        }
        async toggle() {
            if (this.isCollapsed) {
                await this.expand();
            }
            else {
                await this.collapse();
            }
        }
        dispatchExpand() {
            this.dispatchEvent(new CustomEvent(SdsTreeNode.EXPAND_EVENT, {
                detail: {
                    identifier: this.identifier,
                    level: this.level,
                },
                bubbles: false,
                composed: false,
            }));
        }
        dispatchCollapse() {
            this.dispatchEvent(new CustomEvent(SdsTreeNode.COLLAPSE_EVENT, {
                detail: {
                    identifier: this.identifier,
                    level: this.level,
                },
                bubbles: false,
                composed: false,
            }));
        }
    };
    _SdsTreeNode_childCount_accessor_storage = new WeakMap();
    _SdsTreeNode_selected_accessor_storage = new WeakMap();
    _SdsTreeNode_childElements_accessor_storage = new WeakMap();
    _SdsTreeNode_childTreeCells_accessor_storage = new WeakMap();
    _SdsTreeNode_control_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsTreeNode");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _childCount_decorators = [property({ type: Number, attribute: 'child-count' })];
        _selected_decorators = [property({ type: Boolean, reflect: true })];
        _childElements_decorators = [queryAssignedElements({
                selector: 'sds-tree-node, sds-tree-load-more-node, sds-tree-total-data-node',
                flatten: true,
                slot: 'nodes',
            })];
        _childTreeCells_decorators = [queryAssignedElements({
                flatten: true,
                slot: 'data',
                selector: 'sds-tree-cell, sds-tree-cell-container, sds-tree-cell-link, sds-tree-cell-number, sds-tree-cell-skeleton',
            })];
        _control_decorators = [query('#control', true)];
        __esDecorate(_classThis, null, _childCount_decorators, { kind: "accessor", name: "childCount", static: false, private: false, access: { has: obj => "childCount" in obj, get: obj => obj.childCount, set: (obj, value) => { obj.childCount = value; } }, metadata: _metadata }, _childCount_initializers, _childCount_extraInitializers);
        __esDecorate(_classThis, null, _selected_decorators, { kind: "accessor", name: "selected", static: false, private: false, access: { has: obj => "selected" in obj, get: obj => obj.selected, set: (obj, value) => { obj.selected = value; } }, metadata: _metadata }, _selected_initializers, _selected_extraInitializers);
        __esDecorate(_classThis, null, _childElements_decorators, { kind: "accessor", name: "childElements", static: false, private: false, access: { has: obj => "childElements" in obj, get: obj => obj.childElements, set: (obj, value) => { obj.childElements = value; } }, metadata: _metadata }, _childElements_initializers, _childElements_extraInitializers);
        __esDecorate(_classThis, null, _childTreeCells_decorators, { kind: "accessor", name: "childTreeCells", static: false, private: false, access: { has: obj => "childTreeCells" in obj, get: obj => obj.childTreeCells, set: (obj, value) => { obj.childTreeCells = value; } }, metadata: _metadata }, _childTreeCells_initializers, _childTreeCells_extraInitializers);
        __esDecorate(_classThis, null, _control_decorators, { kind: "accessor", name: "control", static: false, private: false, access: { has: obj => "control" in obj, get: obj => obj.control, set: (obj, value) => { obj.control = value; } }, metadata: _metadata }, _control_initializers, _control_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsTreeNode = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.EXPAND_EVENT = 'sds.tree-node.expand';
    _classThis.COLLAPSE_EVENT = 'sds.tree-node.collapse';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsTreeNode = _classThis;
})();
export { SdsTreeNode };
